import { render, staticRenderFns } from "./payment-confirmation-page.vue?vue&type=template&id=920fd6d2&scoped=true&"
import script from "./payment-confirmation-page.vue?vue&type=script&lang=ts&"
export * from "./payment-confirmation-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920fd6d2",
  null
  
)

export default component.exports